export const common = {
  nav: {
    home: 'Home',
    products: 'Products',
    brands: 'Brands',
    services: 'Services',
    contact: 'Contact'
  },
  buttons: {
    requestInfo: 'Request Information',
    loadMore: 'Load More Products',
    requestQuote: 'Request Quote',
    viewCatalog: 'View Catalog',
    sendRequest: 'Send Request'
  },
  hero: {
    title: 'IKIGAI Global Group Inc.',
    subtitle: 'Direct factory distribution of industrial bag sewing machines and original spare parts. Specialists in Newlong (Japan) and Union Special (Germany) from Miami, Florida.',
    cta1: 'View Catalog',
    cta2: 'Request Quote'
  },
  sections: {
    valueProposition: {
      title: 'Our Value Proposition',
      subtitle: 'Direct factory distribution with global presence'
    },
    brands: {
      title: 'World Leading Brands',
      subtitle: 'Distributors of the best industrial machinery brands'
    },
    products: {
      title: 'Our Products',
      subtitle: 'Industrial machines and original spare parts to optimize your operations',
      allProducts: 'All Products'
    },
    industries: {
      title: 'Industries We Serve',
      subtitle: 'Specialized solutions for different industries'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive support to maximize your investment'
    },
    contact: {
      title: 'Contact',
      subtitle: 'We are here to serve you from Miami, Florida'
    }
  }
};